// extracted by mini-css-extract-plugin
module.exports = {"heading":"hero_heading__3T98L","subheading":"hero_subheading__3H6Hf","element":"hero_element__1oWIh","content":"hero_content__21Raa"};